import { Global, css } from '@emotion/react';
import { useMediaQuery, useTheme } from '@mui/material';

import {
  getEditorPageStyles,
  getPrinterContentTypographyStyles,
} from './utils/get-editor-page-styles.util';

export { getEditorPageStyles };

export const EditorPageStyles = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Global
      styles={css`
        ${getEditorPageStyles(matches)}
        ${getPrinterContentTypographyStyles()}
      `}
    />
  );
};
